const middleware = {}

middleware['mapbox'] = require('../middleware/mapbox.js')
middleware['mapbox'] = middleware['mapbox'].default || middleware['mapbox']

export default middleware
